"use client";

import type { ReactNode } from "react";
import {
  FiltersShell,
  SortSelect,
  type FilterGroup,
} from "@/components/sections/comparador/filters-v2";

interface Props {
  groups: FilterGroup[];
  /** Pre-rendered server-side product grid. */
  children: ReactNode;
  /** Optional 300x600 ad on xl+. */
  rightAd?: ReactNode;
  defaultSort?: string;
}

const DEFAULT_SORT_OPTIONS = [
  { value: "relevance", label: "Más relevantes" },
  { value: "discount", label: "Mayor descuento" },
  { value: "price_asc", label: "Menor precio" },
  { value: "price_desc", label: "Mayor precio" },
  { value: "trending", label: "Más populares" },
];

export function ComparadorSearchShell({
  groups,
  children,
  rightAd,
  defaultSort = "relevance",
}: Props) {
  return (
    <FiltersShell
      groups={groups}
      sortControl={
        <SortSelect options={DEFAULT_SORT_OPTIONS} defaultValue={defaultSort} />
      }
      rightAd={rightAd}
      searchPlaceholder="Buscar productos, marcas, tiendas…"
    >
      {children}
    </FiltersShell>
  );
}
